// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"bd50e468","76":"56e4b7ea","229":"fe57610c","354":"50073fb4","397":"0a47ee17","596":"4c8086d5","701":"79302607","784":"cfe4ce1b","785":"b7cb6681","863":"b199903c"}[chunkId] + ".chunk.js";
};